import React from 'react'
import buttonStatusRestrictions from './buttonStatusRestrictions'

const gaTrackCalendarAction = (sessionId, location) => {
  let dataLayer = (window.dataLayer = window.dataLayer || [])
  dataLayer.push({
    event: 'ga-event',
    category: 'Portal',
    action: `Add to Calendar - ${location}`,
    label: sessionId
  })
}

const addToCalendar = (gaTrackingString, setState, state) => {
  const { session } = state
  let sessionType = session.session_type_key === 'session_type_peer_to_peer_meetings' ? session.session_type_key : 'event_session'
  window.api.get(`/virtual_portal/calendar_invite/${sessionType}/${session.id}`).then((response) => {
    let filename = response.headers['content-type'].replace('text/calendar;', '')
    // window.open('data:text/calendar;charset=utf8,' + escape(response.data), '_blank', 'noopener,noreferrer', [`name=${filename}`]);
    // hack so that the filename shows up...I wanted to do the above but the browser assumes the filename as download.
    // Filename may not show up correctly in safari.
    let element = document.createElement('a')
    element.setAttribute('href', 'data:text/calendar;charset=utf-8,' + encodeURIComponent(response.data))
    element.setAttribute('download', filename)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)

    gaTrackCalendarAction(session.id, gaTrackingString)
  }).catch((error) => {
    return(
      setState({
        errorModalIsOpen: true,
        errorStatus: error.response.status,
        errorMessage: 'It looks like something has changed on your schedule. Please REFRESH this page to see your updated schedule.'
      })
    )
  })
}

export const addToCalendarLink = (gaTrackingString, setState, state) => {
  const { session, meetingEnded } = state
  if ((session.registration_status === 'un_register') && !meetingEnded && !buttonStatusRestrictions(state)) {
    return (
      <a onClick={ () => addToCalendar(gaTrackingString, setState, state) } className='add-to-calendar'><i className='fa fa-calendar' aria-hidden='true'></i> 
        ADD TO CALENDAR
      </a>
    )
  }
}